exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".container-img {\n  position: relative;\n}\n.container-img .ant-carousel .slick-slide {\n  overflow: hidden;\n}\n.container-img .ant-carousel div {\n  height: 100vh;\n  overflow: hidden;\n  cursor: pointer;\n}\n.container-img .left-arrow,\n.container-img .right-arrow {\n  font-size: 40px;\n  color: #e8e8e8;\n  cursor: pointer;\n}\n.container-img .left-arrow {\n  position: absolute;\n  top: 50%;\n  left: 2%;\n}\n.container-img .right-arrow {\n  position: absolute;\n  top: 50%;\n  right: 2%;\n}\n", ""]);

// exports
